import Container from 'react-bootstrap/Container';
import RoadmapGet from '../services/RoadmapGet';

function Roadmap() {
  return (
    <div>
      <Container>
        <RoadmapGet />
      </Container>
    </div>
  );
}

export default Roadmap;